import React, {
    Component
} from 'react'
import {
    Link,
    NavLink
} from 'react-router-dom'

import _ from 'lodash-joins';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';

import fetch from '~/utils/fetch';
import { actionTypes } from '~/constants';
import XInput from '~/widgets/x-input';

import { State as StateEnums } from '@exmarx/shared/enums/State';

const STATE_NAMES = [];
for(const State in StateEnums){
    STATE_NAMES.push({
        label: State,
        value: State
    });
}

class ModalSimpleModal extends Component {
    constructor() {
        super()

        this.initialState = {
            reporter: null,
            notes: '',
            address: {
                'street': '',
                'streetExt': '',
                'city': '',
                'state': '',
                'country': '',
                'zip': '',
            },
            latitude: 0.0,
            longitude: 0.0,
            error: null,
            vcaClaimId: '',
            accidentNumber: '',
        }

        if(__STAGE__ !== 'production'){
            this.initialState = {
                ...this.initialState,
                notes: 'Test notes.',
                address: {
                    'street': '123 Stone St.',
                    'streetExt': 'Ste. 21',
                    'city': 'New York',
                    'state': 'NY',
                    'country': 'USA',
                    'zip': '10123',
                },
            }
        }

        this.state = {...this.initialState};
    }

    handleSubmit(e) {
        e.preventDefault();
        const user = this.props.users.list.find(x=>x.cognitoId===this.state.reporter);
        if(!user){
            this.props.dispatch({
              type: actionTypes.SNACKBAR,
              snackbar: {
                severity: 'error',
                text: `Please select a Reporter.`
              }
            });
            return;
        }
        this.props.dispatch({
            type: actionTypes.REPORTS_CREATE_ONE,
            data: {
                reporter: user.cognitoId,  // @FIXME refactor to _id instead of cognitoId
                reporterEmail: user.email,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                address: `${this.state.address.street}, ${this.state.address.streetExt}, ${this.state.address.city}, ${this.state.address.state}, ${this.state.address.zip}, ${this.state.address.country}`,
                notes: this.state.notes,
                vcaClaimId: this.state.vcaClaimId,
                accidentNumber: this.state.accidentNumber,
            }
        })
        this.props.closeModal();
    }

    bindState(path, value) {
        const newState = Object.assign({}, this.state);
        _.set(newState, path, value);
        this.setState(newState);
    }

    render() {
        let users = this.props.users.list;

        console.log(this.state)

        // sort alphabetically
        users = _.sortBy(users, u=>u.firstname);

        // group by department id
        users = _.groupBy(users, u=>u.clientId);

        let departments = this.props.departments.list;
        departments = departments.map(d=>({
            ...d,
            _users: _.get(users, [d._id], []),
        }))

        const the_choices = _.flatMap(departments.map(department=>{
            let choices = [];
            choices.push({
                label: `${department.name}`,
                value: null,
                heading: true
            })
            for(let user of department._users){
                choices.push({
                    label: `${user.firstname} ${user.lastname} <${user.email}>`,
                    value: user.cognitoId,
                });
            }
            return choices;
        }));

        return (
            <form className="modal-reports-create-report modal" onSubmit={this.handleSubmit.bind(this)}>
                <input type="submit" style={{display: 'none'}}/>
                <div className="modal-header">
                    <div className="modal-title">
                        Create Report
                    </div>
                    <a onClick={this.props.closeModal} className="modal-dismiss">
                        <img src={`/dist/assets/img/ic-close.svg`}/>
                    </a>
                </div>
                <div className="modal-content">
                    <div className="instructions">
                        Reports created here are <strong>not automatically</strong> submitted to VCA.
                    </div>
                    <div className="form-section">
                        <div className="form-section-heading">
                            Report Information
                        </div>
                        <div className="form-row">
                            <XInput
                                label="Reporter"
                                required={true}
                                name='state'
                                handleChange={this.bindState.bind(this, 'reporter')}
                                value={this.state.reporter}
                                choices={the_choices}
                                style={{minWidth: '85px'}}
                            />
                        </div>
                        <div className="form-row">
                            <XInput
                                label="VCA Claim ID (optional)"
                                required={false}
                                name='vcaClaimId'
                                handleChange={this.bindState.bind(this, 'vcaClaimId')}
                                value={this.state.vcaClaimId}
                            />
                            <div className="spacer"/>
                            <XInput
                                label="Accident Number (optional)"
                                required={false}
                                name='accidentNumber'
                                handleChange={this.bindState.bind(this, 'accidentNumber')}
                                value={this.state.accidentNumber}
                            />
                        </div>
                        <div className="form-row">
                            <XInput
                                label="Street"
                                required={true}
                                name='street'
                                handleChange={this.bindState.bind(this, 'address.street')}
                                value={this.state.address.street}
                            />
                            <div className="spacer"/>
                            <XInput
                                label="Street Ext"
                                required={false}
                                name='streetExt'
                                handleChange={this.bindState.bind(this, 'address.streetExt')}
                                value={this.state.address.streetExt}
                            />
                        </div>
                        <div className="form-row">
                            <XInput
                                label="City"
                                required={true}
                                name='city'
                                handleChange={this.bindState.bind(this, 'address.city')}
                                value={this.state.address.city}
                            />
                            <div className="spacer"/>
                            <XInput
                                label="State"
                                required={true}
                                name='state'
                                handleChange={this.bindState.bind(this, 'address.state')}
                                value={this.state.address.state}
                                choices={STATE_NAMES}
                                style={{minWidth: '85px'}}
                            />
                            <div className="spacer"/>
                            <XInput
                                label="Postal Code"
                                required={true}
                                name='zip'
                                handleChange={this.bindState.bind(this, 'address.zip')}
                                value={this.state.address.zip}
                            />
                        </div>
                        <div className="form-row">
                            <XInput
                                label="Country"
                                required={true}
                                name='country'
                                handleChange={this.bindState.bind(this, 'address.country')}
                                value={this.state.address.country}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-section-heading">
                            Additional Information
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-row">
                            <XInput
                                label="Notes"
                                required={false}
                                multiline={true}
                                rows={3}
                                name='notes'
                                handleChange={this.bindState.bind(this, 'notes')}
                                value={this.state.notes}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div onClick={this.handleSubmit.bind(this)} className="button button-primary">
                        Submit
                    </div>
                </div>
            </form>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            users: state.users,
            departments: state.departments,
            reports: state.reports,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    }
)(ModalSimpleModal);